import { IFieldValuesEncriptionDetailsServer } from "@common/redux/forms/interface";
import { IWriteJavascript } from "../FormTextInputField/interface";

export interface IDatepickerFieldConfigurationServer {
  initialValue?: string;
  placeHolder?: string;
  isDuplicateAllowed?: boolean;
  isPII?: boolean;
  encryptDetails?: IFieldValuesEncriptionDetailsServer;
  isQrCodeAllowed?: boolean;
  writeJavascript?: IWriteJavascript;
  dateFormat?: string;
  dateRangeEnabled?: boolean;
  isWeekendDisabled?: boolean;
  specificDateSelectionEnabled?: boolean;
  specificDateRangeEnabled?: boolean;
  jsonApiEnabled?: boolean;
  preDisableDateCount?: string;
  postDisableDateCount?: string;
  specificDates?: any;
  specificDateRange?: any;
  dateJsonApiUrl?: string;
  isPartOfTimeSlot?: boolean;
  isCurrentDateSelected?: boolean;
  dateInitialValueType?: string;
  isPastDateDisabled?: boolean;
  fromFieldId?: string;
  toFieldId?: string;
  isMonthDisplayRequired?: boolean;
  monthDisplayFieldId?: string;
}

export interface IDatepickerFieldConfigurationClient {
  initialValue?: string;
  writeJavascript?: IWriteJavascript;
  dateFormat?: string;
  dateRangeEnabled?: boolean;
  isWeekendDisabled?: boolean;
  specificDateSelectionEnabled?: boolean;
  specificDateRangeEnabled?: boolean;
  jsonApiEnabled?: boolean;
  preDisableDateCount?: string;
  postDisableDateCount?: string;
  specificDates?: any;
  specificDateRange?: any;
  dateJsonApiUrl?: string;
  isPartOfTimeSlot?: boolean;
  isCurrentDateSelected?: boolean;
  dateInitialValueType?: string;
  isPastDateDisabled?: boolean;
  fromFieldId?: string;
  toFieldId?: string;
  isMonthDisplayRequired?: boolean;
  monthDisplayFieldId?: string;
}
export const enum DateInitialValueType {
  currentDate = "currentDate",
  setInitialValue = "setInitialValue",
  initialValueWithAccessKey = "ACCESS_KEY",
}
export interface IInitialValueRender {
  type: DateInitialValueType;
  onDateChange: (value: Date) => void;
  value: string;
  onAccessKeyChange: (value: string) => void;
}
